import { useEffect, useState } from "react";
import DownChevron from "../../assets/images/down-chevron.svg";
import Search from "../../assets/images/search.svg";
import Cancel from "../../assets/images/cancel.svg";
import { useTranslation } from "react-i18next";

function MobileMenu({ closeMenu, clearFilters, fabricMenu, patternMenu, designMenu, sortMenu, updateFilterValue, selectedInps, sortType, setSortType, patternSelection }) {
  const [ t ] = useTranslation();

  const [openSections, setOpenSections] = useState([]);
  const [family, setFamily] = useState([]);
  const [pattern, setPattern] = useState();
  const [direction, setDirection] = useState(sortType);

  useEffect(() => {
    setFamily(fabricMenu)
    setPattern(patternSelection)
  }, [fabricMenu, patternSelection])

  useEffect(() => {
    setDirection(sortType)
  }, [sortType])

  const familySearch = (value) => {
    setFamily(
      fabricMenu.filter(entry => (entry.title_de ? entry.title_de : entry.name ? entry.name : entry.value ? entry.value : entry.label ? entry.label : entry).toLowerCase()
      .includes(value.toLowerCase()))
    )
  }

  const openSection = (section) => {
    if (!openSections?.includes(section)) {
      setOpenSections(openSections?.length > 0 ? [...openSections, section] : [section]);
    } else {
      setOpenSections(openSections?.filter(entry => entry !== section))
    }
  }


  return (
    <div className="filters-sheet">
      <div className="overlay"></div>
      <div className="content">
        <div className="head">
          <p className="title">{t('filters.filter')}</p>
          <img className="close-modal filters-sheet-close" src={Cancel} alt="" onClick={() => {
            clearFilters();
            closeMenu();
          }} />
        </div>
        <div className={"section " + (openSections.includes("Stoff") ? "active" : "")}>
          <p className="section-label" onClick={() => openSection("Stoff")}>{t('filters.fabric')} <img src={DownChevron} alt="" /></p>
          <div className="family-panel mobile-view">
            <div className="search">
              <img src={Search} alt="" />
              <input type="text" placeholder={t('filters.search_by_fabric')} onChange={e => familySearch(e.target.value)} />
            </div>
            <div className="result-list mobile-ff-list">
              {family?.map((entry, key) =>
                <div className="entry" key={key}>
                  <input id={"family-fabrics" + entry.id} type="checkbox" value={entry.id} onChange={() => updateFilterValue("fabric", entry.id)} checked={selectedInps.includes(entry.id)} />
                  <label htmlFor={"family-fabrics" + entry.id} className="details">
                    <p className="label">{t(entry.name)}</p>
                    <div className="preview">
                      <p className="is-selected">{t('filters.selected')}</p>
                    </div>
                  </label>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className={"section " + (openSections.includes("Muster") ? "active" : "")}>
          <p className="section-label" onClick={() => openSection("Muster")}>{t('filters.pattern')} <img src={DownChevron} alt="" /></p>
          <div className="choices">
            {patternMenu.map((entry) =>
              <div className={"card " + (pattern === entry.value ? "active" : "")} onClick={() => updateFilterValue("pattern", entry.value)} key={entry.name}>
                <div className="preview" style={{ backgroundImage: `url(${entry.image})`, }}></div>
                <p>{t(entry.name)}</p>
              </div>
            )
            }
          </div>
        </div>
        <div className={"section " + (openSections.includes("Design") ? "active" : "")}>
          <p className="section-label" onClick={() => openSection("Design")}>Design <img src={DownChevron} alt="" /></p>
          {designMenu.map((entry, key) =>
            <div className="inp-group" key={key}>
              <input type="radio" id={"mob-" + entry.value} name="design" value={entry.value} onChange={() => updateFilterValue("design", entry.value)} />
              <label htmlFor={"mob-" + entry.value}>{t(entry.name)}</label>
            </div>
          )}
        </div>
        <div className={"section " + (openSections.includes("Sortieren nach") ? "active" : "")}>
          <p className="section-label" onClick={() => openSection("Sortieren nach")}>{t('filters.sort_by')} <img src={DownChevron} alt="" /></p>
          <div className="orderby">
            {t('filters.order')} <div className={"btn " + (direction === "desc" ? "active" : "")} onClick={() => setSortType("desc")}>Desc</div>
            <div className={"btn " + (direction === "asc" ? "active" : "")} onClick={() => setSortType("asc")}>Asc</div>
          </div>
          {sortMenu.map((entry, key) =>
            <div className="inp-group" key={key}>
              <input type="radio" id={"mob-" + entry.value} name="sort" value={entry.value} onChange={() => updateFilterValue("sort", entry.value)} />
              <label htmlFor={"mob-" + entry.value}>{t(entry.name)}</label>
            </div>
          )}
        </div>
        <div className={"section " + (openSections.includes("Hemd der Woche") ? "active" : "")}>
          <p className="section-label" onClick={() => openSection("Hemd der Woche")}>{t('filters.shirt_of_the_week')}<img src={DownChevron} alt="" /></p>
          <div className="inp-group">
            <input type="radio" id="mobile-sotw-only" name="sotw" value="only" onClick={() => updateFilterValue("sotw", true)} />
            <label htmlFor="mobile-sotw-only">{t('filters.only')}</label>
          </div>
          <div className="inp-group">
            <input type="radio" id="mobile-sotw-all" name="sotw" value="all" onClick={() => updateFilterValue("sotw", false)} />
            <label htmlFor="mobile-sotw-all">{t('filters.all')}</label>
          </div>
        </div>

        <div className="apply-filters-btn" onClick={() => closeMenu()}>
          {t('filters.apply_filter')}
        </div>
      </div>
    </div>
  );
}

export default MobileMenu